import { baseApiUrl } from '../../config/env';
import AsyncStoreService from '../async-store.service';

const getToken = async () => {
  const token = await AsyncStoreService.getTokenData();
  if (!token) {
    return { error: 'User is not logged' };
  }
  return token;
};

const _GET = async (path, token) => {
  try {
    const res = await fetch(`${baseApiUrl}${path}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: 'Bearer ' + token.access_token,
      },
    });

    return res;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const GET = async (path) => {
  const token = await getToken();
  const res = await _GET(path, token);

  if (!res) {
    return null;
  }
  return res.json();
};

const POST = async (path, data) => {
  const token = await getToken();

  const res = await fetch(`${baseApiUrl}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: 'Bearer ' + token.access_token,
    },
    body: 'param=' + encodeURIComponent(JSON.stringify(data)),
  });

  return res.json();
};

export const getProfile = async () => {
  return await GET('/User/Profile');
};

export const getImage = async () => {
  const token = await getToken();

  return await _GET(`/user/image/${token.userId}`, token);
};

export const getInfo = async () => {
  return await GET('/user/info');
};

export const getCountryList = async () => {
  return await GET('/User/GetCountryList');
};

export const getAirVendor = async () => {
  return await GET('/User/GetAirVendor');
};

export const getHotelVendor = async () => {
  return await GET('/User/GetHotelVendor');
};

export const getCarVendor = async () => {
  return await GET('/User/GetCarVendor');
};

export const getCreditCard = async () => {
  return await GET('/User/GetCreditCard');
};

export const getLoyaltyAir = async () => {
  return await GET('/User/GetLoyaltyAir');
};

export const getLoyaltyHotel = async () => {
  return await GET('/User/GetLoyaltyHotel');
};

export const getLoyaltyCar = async () => {
  return await GET('/User/GetLoyaltyCar');
};

export const getLoyaltyRail = async () => {
  return await GET('/User/GetLoyaltyRail');
};

export const getApproval = async () => {
  return await GET('/User/GetApproval');
};

export const saveApproval = async (data) => {
  return await POST('/User/SaveApprover', data);
};

// POST
export const updateProfile = async (data) => {
  return await POST('/User/UpdateProfile', data);
};

export const updatePicture = async (data) => {
  return await POST('/User/UpdatePicture', data);
};

export const deletePicture = async (data) => {
  return await POST('/User/DeletePicture', data);
};

export const saveCreditCard = async (data) => {
  return await POST('/User/Savecard', data);
};

export const deleteCreditCard = async (data) => {
  return await POST('/User/DeleteCreditCard', data);
};

export const saveAirLoyalty = async (data) => {
  return await POST('/User/SaveAirLoyalty', data);
};

export const saveHotelLoyalty = async (data) => {
  return await POST('/User/SaveHotelLoyalty', data);
};

export const saveCarLoyalty = async (data) => {
  return await POST('/User/SaveCarLoyalty', data);
};

export const saveRailLoyalty = async (data) => {
  // Bad API, the API should be changed, this is hard code
  return await GET(
    `/User/SaveRailLoyalty?vendorCode=${data[0].VendorCode}&program=${data[0].ProgramNumber}&vendorId=${data[0].VendorId}`
  );
};

export const deleteAirLoyalty = async (prefKey) => {
  return await GET(`/User/DeleteAirLoyalty?airPrefKey=${prefKey}`);
};

export const deleteHotelLoyalty = async (prefKey) => {
  return await GET(`/User/DeleteHotelLoyalty?hotelPrefKey=${prefKey}`);
};

export const deleteCarLoyalty = async (prefKey) => {
  return await GET(`/User/DeleteCarLoyalty?carPrefKey=${prefKey}`);
};

export const deleteRailLoyalty = async (prefKey) => {
  return await GET(`/User/DeleteRailLoyalty?railPrefKey=${prefKey}`);
};

export const changePassword = async (data) => {
  return await POST('/User/ChangePassword', data);
};

export const getCardBillingDetails = async (data) => {
  return await POST('/User/GetCardBillingDetails', data);
};

export const getStates = async (country) => {
  return await GET(`/User/GetStates?CountryCode=${country}`);
};

export const getGroupDetails = async () => {
  return await GET('/User/GetGroupDetails');
};

export const getUserRoleDetails = async () => {
  return await GET('/User/GetUserRoleDetails');
};

export const getNotification = async () => {
  return await GET('/User/GetNotification');
};
